/* eslint-disable class-methods-use-this */
import http from '../httpService';
import { AccountingResourceRequest } from './dto/requestModels';
import { VaultSessionResponse } from './dto/responseModels';

class AccountingService {

  public async connectAccounting(request: AccountingResourceRequest) {
    await http.post('api/services/app/Accounting/ConnectAccountingProvider', request);
  }

  public async disconnectAccounting(request: AccountingResourceRequest) {
    await http.post('api/services/app/Accounting/DisconnectAccountingProvider', request);
  }

  public async createSession(): Promise<VaultSessionResponse> {
    const result = await http.post('api/services/app/Accounting/CreateSession');
    return result.data.result;
  }
}

export default new AccountingService();
